(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahd_main_banner"] && !window.DesignMode) return;
  try {
    

let bannerSlides = document.querySelectorAll('.banner-slide');
let bannerDots = document.querySelectorAll('.banner-dot');
let bannerCurrentIndex = 0;
let bannerSlideInterval = setInterval(bannerNextSlide, 7000); // Change slide every 7 seconds

function bannerNextSlide() {
    bannerSlides[bannerCurrentIndex].classList.remove('banner-slide-active');
    bannerDots[bannerCurrentIndex].classList.remove('banner-dot-active');
    bannerCurrentIndex = (bannerCurrentIndex + 1) % bannerSlides.length;
    bannerUpdateSliderPosition();
}

function bannerPreviousSlide() {
    bannerSlides[bannerCurrentIndex].classList.remove('banner-slide-active');
    bannerDots[bannerCurrentIndex].classList.remove('banner-dot-active');
    bannerCurrentIndex = (bannerCurrentIndex - 1 + bannerSlides.length) % bannerSlides.length;
    bannerUpdateSliderPosition();
}

function bannerUpdateSliderPosition() {
    let newTransformValue = `translateX(-${bannerCurrentIndex * 100}%)`;
    document.querySelector('.banner-slider').style.transform = newTransformValue;
    bannerSlides[bannerCurrentIndex].classList.add('banner-slide-active');
    bannerDots[bannerCurrentIndex].classList.add('banner-dot-active');
}

bannerDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
        clearInterval(bannerSlideInterval);
        bannerSlides[bannerCurrentIndex].classList.remove('banner-slide-active');
        bannerDots[bannerCurrentIndex].classList.remove('banner-dot-active');
        bannerCurrentIndex = index;
        bannerUpdateSliderPosition();
        bannerSlideInterval = setInterval(bannerNextSlide, 7000);
    });
});

// Draggable functionality
let bannerStartX, bannerEndX;
const bannerThreshold = 50;

document.querySelector('.banner-slider').addEventListener('mousedown', (e) => {
    bannerStartX = e.clientX;
});

document.querySelector('.banner-slider').addEventListener('mouseup', (e) => {
    bannerEndX = e.clientX;
    if (bannerStartX > bannerEndX + bannerThreshold) {
        bannerNextSlide();
    } else if (bannerEndX > bannerStartX + bannerThreshold) {
        bannerPreviousSlide();
    }
});

document.querySelector('.banner-slider').addEventListener('touchstart', (e) => {
    bannerStartX = e.touches[0].clientX;
});

document.querySelector('.banner-slider').addEventListener('touchend', (e) => {
    bannerEndX = e.changedTouches[0].clientX;
    if (bannerStartX > bannerEndX + bannerThreshold) {
        bannerNextSlide();
    } else if (bannerEndX > bannerStartX + bannerThreshold) {
        bannerPreviousSlide();
    }
});

// Prevent default behavior for images to ensure dragging works
document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('dragstart', (e) => {
        e.preventDefault();
    });
});

// Custom cursor functionality
// const bannerCustomCursor = document.querySelector('.custom-banner-cursor');
// const bannerHero = document.querySelector('.banner-hero');
// const bannerClickableElements = document.querySelectorAll('button, .banner-dot');

// bannerHero.addEventListener('mousemove', (e) => {
//     bannerCustomCursor.style.left = `${e.clientX}px`;
//     bannerCustomCursor.style.top = `${e.clientY}px`;
//     bannerCustomCursor.style.transform = 'translate(-50%, -50%)'; // Center the cursor on the mouse pointer
// });

// bannerHero.addEventListener('mouseenter', () => {
//     bannerCustomCursor.style.display = 'flex';
// });

// bannerHero.addEventListener('mouseleave', () => {
//     bannerCustomCursor.style.display = 'none';
// });

// bannerClickableElements.forEach(el => {
//     el.addEventListener('mouseenter', () => {
//         bannerCustomCursor.textContent = "click";
//         bannerCustomCursor.classList.add('banner-cursor-link-hover');
//     });
//     el.addEventListener('mouseleave', () => {
//         bannerCustomCursor.textContent = "drag";
//         bannerCustomCursor.classList.remove('banner-cursor-link-hover');
//     });
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a_product_info"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
      const buttons = document.querySelectorAll('.z_product_details_tab_button');
      const panes = document.querySelectorAll('.z_product_details_tab_pane');

      buttons.forEach(button => {
          button.addEventListener('click', () => {
              buttons.forEach(btn => btn.classList.remove('z_product_details_active'));
              button.classList.add('z_product_details_active');

              const target = button.getAttribute('data-target');
              panes.forEach(pane => {
                  pane.classList.remove('z_product_details_active');
                  if (pane.id === target) {
                      pane.classList.add('z_product_details_active');
                  }
              });
          });
      });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
